import useEligibleUSPayment from './useEligibleUSPayment';

/**
 * Returns data on HSA/FSA availability, eligibility, enabled/disabled
 *
 * Country Eligibility favors billing address country but falls back to
 * app country so we can utiize this outside of checkout e.g. to display
 * HSA/FSA messaging on the PDP, footer, etc
 */

export const useHsaFsa = (): {
  isAvailable: boolean; // combination of all factors listed below
  isEligible: boolean; // based solely on location, item, etc
  isEnabled: boolean; // based solely on feature gates, flags, experiment, etc
} => {
  const isEligibleUSPayment = useEligibleUSPayment();

  const isEligible = isEligibleUSPayment;
  const isEnabled = true; // currently no flags or experiments, so always enabled

  return {
    isAvailable: isEligible && isEnabled,
    isEligible,
    isEnabled,
  };
};
